import { List } from 'immutable';
import { State } from 'flow/types/State';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';

export const selectMainNumberOptions = (state: State) =>
    state.profiles
        .get('main_numbers', List())
        .map((n) => ({ id: n.get('key'), name: n.get('description') }))
        .toArray();

export const selectProfileRecordCalls = (state: State) =>
    state.profiles
        .get(selectOwnExtensionKey(state), List())
        ?.first()
        ?.get('recordCalls');

export const selectCanEditProfilesOfUser = (
    state: State,
    targetExtensionKey: ExtensionKey,
) => !state.profiles.get(targetExtensionKey, List()).isEmpty();
